module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_10.36e2c4c5.jpg";